<script setup lang="ts">
import type { IProps } from './UiHeader.types'

defineProps<IProps>()

const attrs = useAttrs()
</script>

<template>
  <h2
    :id="attrs.id"
    :class="[
      'ui-header',
      `ui-header__desktop-${headerSize}`,
      `ui-header__tablet-${headerSizeTablet}`,
      `ui-header__${headerSizeMobile}`
    ]"
    :style="{ textAlign: position }"
    v-html="header"
  />

  <div
    v-if="subheader"
    :class="[
      'ui-header__subheader',
      `ui-header__desktop-${subheaderSize}`,
      `ui-header__tablet-${subheaderSizeTablet}`,
      `ui-header__${subheaderSizeMobile}`
    ]"
    :style="{ textAlign: position }"
    v-html="subheader"
  />
</template>

<style lang="scss" scoped>
.ui-header {
  font-weight: 500;
  font-size: 2.8rem;
  line-height: 3.6rem;

  :deep() {
    span {
      color: var(--span-color);
    }
  }

  @include atM {
    font-size: 4.8rem;
    line-height: 5.6rem;
  }

  @include atXL {
    font-size: 5.6rem;
    line-height: 6.8rem;
  }

  &__subheader {
    margin-top: 2.4rem;
    font-weight: 500;
    font-size: 1.8rem;
    line-height: 2.4rem;
    text-align: center;

    :deep() {
      span {
        color: $text-200;
      }
    }

    @include atM {
      margin-top: 3.2rem;
      font-size: 2rem;
      line-height: 2.8rem;
    }

    @include atXL {
      font-size: 2.4rem;
      line-height: 3.2rem;
    }
  }

  &__h1 {
    @include h1;
  }

  &__h2 {
    @include h2;
  }

  &__h3 {
    @include h3;
  }

  &__h4 {
    @include h4;
  }

  &__h5 {
    @include h5;
  }

  &__h6 {
    @include h6;
  }

  &__h7 {
    @include h7;
  }

  &__h8 {
    @include h8;
  }

  &__h9 {
    @include h9;
  }

  &__h10 {
    @include h10;
  }

  &__h11 {
    @include h11;
  }

  &__body-1 {
    @include body-1-medium;
  }

  &__body-2 {
    @include body-2-medium;
  }

  &__body-3 {
    @include body-3-medium;
  }
}

@include atM {
  .ui-header {
    &__desktop-h1 {
      @include h1;
    }

    &__desktop-h2 {
      @include h2;
    }

    &__desktop-h3 {
      @include h3;
    }

    &__desktop-h4 {
      @include h4;
    }

    &__desktop-h5 {
      @include h5;
    }

    &__desktop-h6 {
      @include h6;
    }

    &__desktop-h7 {
      @include h7;
    }

    &__desktop-h8 {
      @include h8;
    }

    &__desktop-h9 {
      @include h9;
    }

    &__desktop-h10 {
      @include h10;
    }

    &__desktop-h11 {
      @include h11;
    }

    &__desktop-body-1 {
      @include body-1-medium;
    }

    &__desktop-body-2 {
      @include body-2-medium;
    }

    &__desktop-body-3 {
      @include body-3-medium;
    }
  }
}

@include atXS {
  .ui-header {
    &__tablet-h1 {
      @include h1;
    }

    &__tablet-h2 {
      @include h2;
    }

    &__tablet-h3 {
      @include h3;
    }

    &__tablet-h4 {
      @include h4;
    }

    &__tablet-h5 {
      @include h5;
    }

    &__tablet-h6 {
      @include h6;
    }

    &__tablet-h7 {
      @include h7;
    }

    &__tablet-h8 {
      @include h8;
    }

    &__tablet-h9 {
      @include h9;
    }

    &__tablet-h10 {
      @include h10;
    }

    &__tablet-h11 {
      @include h11;
    }

    &__tablet-body-1 {
      @include body-1-medium;
    }

    &__tablet-body-2 {
      @include body-2-medium;
    }

    &__tablet-body-3 {
      @include body-3-medium;
    }
  }
}
</style>
